/**
 * Date and time helpers, ported from legacy `src/utils/functions.ts`.
 */

/**
 * Left-pads a clock component to two digits: `7` -> `'07'`, `'7'` -> `'07'`.
 *
 * The legacy version branched on `typeof` and ended with
 * `throw new Error('Unsupported type' + typeof time)` for a case its own signature
 * (`string | number`) made unreachable. Dropped: `String(value)` handles both inputs
 * identically, so the impossible branch cannot be constructed and a display can never
 * crash inside a clock format.
 */
export function timePadding(value: string | number): string {
  return String(value).padStart(2, '0');
}
